import { Splide } from '@hh/global.js'

class SearchPagesCarousel extends HTMLElement {
  constructor() {
    super()
    this.splide = null
  }

  connectedCallback() {
    // Wait until inner HTML is rendered
    requestAnimationFrame(() => {
      this.init()
    })
  }

  disconnectedCallback() {
    if (this.splide) {
      this.splide.destroy()
      this.splide = null
    }
  }

  init() {
    const carouselEl = this.querySelector('.js-pages-carousel')
    if (!carouselEl) return

    // Prevent double mount
    if (carouselEl.classList.contains('is-initialized')) return

    this.splide = new Splide(carouselEl, {
      arrows: true,
      pagination: false,
      useScroll: true,
      type: 'slide',
      perPage: 2,
      gap: '14px',
      cloneStatus: false,
      rewind: true,
      start: 0,
      breakpoints: {
        768: {
          perPage: 1,
          pagination: false,
          arrows: true,
        },
      },
    })

    this.splide.mount()

    carouselEl.classList.add('is-initialized')
  }
}

customElements.define('search-pages-carousel', SearchPagesCarousel)
